// extracted by mini-css-extract-plugin
module.exports = {"accountsSection":"AccountTree_accountsSection__3Ro3a"};